/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2021-12-07 20:01:31
 * @LastEditTime: 2023-10-08 11:06:50
 * @LastEditors: 赵大壮
 */
import nyNetwork from "@/api/nyBaseNetwork";
import nyMessageToast from "@/utils/NYMessageToast";
class DZUserService {

    s_username = '';
    s_password = '';


    doLogin(success: (res: any) => void) {
        if (this.s_username.nyIsEmpty()) {
            nyMessageToast.warning("请输入用户名")
            return
        }

        if (this.s_password.nyIsEmpty()) {
            nyMessageToast.warning("请输入密码")
            return
        }
        var params = {
            account: this.s_username,
            password: this.s_password
        };

        var that = this;
        nyNetwork.net('后台登录', params, (data) => {
            success(data);
        });
    }
}

export default DZUserService
